import { apiUrl, currentUser, pollInterval, set } from '../state';
import type { ApiResult } from '../types';

export async function callApi(body: Record<string, unknown>): Promise<ApiResult> {
  if (!currentUser) return { ok: false, error: 'Not authenticated' };
  try {
    const res = await fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify({ ...body, token: currentUser.token }),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${currentUser.token}`,
      },
      redirect: 'follow',
    });
    if (res.status === 401) { sessionExpired(); return { ok: false, error: 'Session หมดอายุ' }; }
    if (res.status === 403) {
      const d: ApiResult = await res.json();
      import('./ui').then(({ toast }) => toast('error', d.error ?? 'ไม่มีสิทธิ์ดำเนินการนี้'));
      return { ok: false, error: d.error };
    }
    return await res.json();
  } catch (err) {
    return { ok: false, error: (err as Error).message };
  }
}

export async function callGet(action: string): Promise<ApiResult> {
  if (!currentUser) return { ok: false, error: 'Not authenticated' };
  try {
    const res = await fetch(`${apiUrl}?action=${encodeURIComponent(action)}`, {
      redirect: 'follow',
      headers: { 'Authorization': `Bearer ${currentUser.token}` },
    });
    if (res.status === 401) { sessionExpired(); return { ok: false }; }
    return await res.json();
  } catch (err) {
    return { ok: false, error: (err as Error).message };
  }
}

export function sessionExpired(): void {
  sessionStorage.removeItem('hr_session');
  set.currentUser(null);
  if (pollInterval) clearInterval(pollInterval);
  import('./auth').then(({ showAuthPopup }) => {
    showAuthPopup('warning', 'Session หมดอายุ', 'กรุณาล็อกอินใหม่', [
      { label: 'ล็อกอินใหม่', cls: 'ok', cb: () => location.reload() },
    ]);
  });
}
